var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.013 319.988H399.986C441.607 319.988 463.48 270.359 435.359 239.607L259.373 47.469C240.373 26.844 207.627 26.844 188.627 47.469L12.64 239.607C-15.481 270.234 6.392 319.988 48.013 319.988ZM399.992 384.023H48.004C21.611 384.023 0.017 405.617 0.017 432.01V432.01C0.017 458.404 21.613 480 48.008 480H399.996C426.388 480 447.982 458.406 447.982 432.014V432.014C447.982 405.619 426.387 384.023 399.992 384.023Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEject);
export default __webpack_public_path__ + "static/media/eject.4215e229711f9af507fd832aac6966d7.svg";
export { ForwardRef as ReactComponent };